import {createFeatureSelector, createSelector} from "@ngrx/store";
import {TechInfoState} from "@tech/pages/infos/store/tech-info.state";

export const techInfoStoreSelect = createFeatureSelector<TechInfoState>('techInfos');

export const selectInfoPageList = createSelector(
  techInfoStoreSelect,
  (state: TechInfoState) => state.infoList
);

export const selectInfoPagePagination = createSelector(
  techInfoStoreSelect,
  (state: TechInfoState) => state.paging
);

export const selectInfoPageLoading = createSelector(
  techInfoStoreSelect,
  (state: TechInfoState) => state.isLoading
);

export const selectInfoPageLoadingId = createSelector(
  techInfoStoreSelect,
  (state: TechInfoState) => state.isLoadingId
);
